import { Step } from 'signup-constants/Step';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { isPreVerification } from '../../flow-settings/settingsSelectors';
import { getIsExistingUserSession } from '../../store/app/selectors';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { getStepConfig } from '../../views/getStepConfig';
import { setFlowForACQ145 } from '../../experiments/acq0145/ACQ145Utils';
export const BranchACQ145 = {
  name: 'BranchACQ145',
  stateCheck: state => {
    return getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0145, [ExperimentParameterGroup.Variant_A]);
  },
  rebuildFlow: (flow, state, dispatch) => {
    const stepConfig = getStepConfig(Step.HubletSelection);
    if (stepConfig) {
      stepConfig.showNextButtonIcon = false;
    }
    const nextSteps = dispatch(setFlowForACQ145({
      isPreVerificationExistingUserSession: getIsExistingUserSession(state) && isPreVerification()
    }));
    return nextSteps;
  },
  processed: false,
  processedOnStep: Step.LandingPage,
  afterData: null,
  afterStep: null
};